/**
 * @module Viewport Dims
 * @description Sets viewport dimensions using verge on shared state
 * and detects mobile or desktop state.
 */
import { viewportH, viewportW } from 'verge';
import state from '@/js/config/state';
import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT, DESKTOP_BREAKPOINT } from '@/js/config/options';

/**
 * @function viewportDims
 * @description
 */
const viewportDims = () => {
  state.v_height = viewportH();
  state.v_width = viewportW();

  if ( state.v_width < MOBILE_BREAKPOINT ) {
    state.is_mobile = true;
    state.is_tablet = false;
    state.is_desktop = false;
    state.is_desktopXL = false;
  } else if ( state.v_width >= MOBILE_BREAKPOINT && state.v_width < TABLET_BREAKPOINT ) {
    state.is_mobile = false;
    state.is_tablet = true;
    state.is_desktop = false;
    state.is_desktopXL = false;
  } else if ( state.v_width >= TABLET_BREAKPOINT && state.v_width < DESKTOP_BREAKPOINT ) {
    state.is_mobile = false;
    state.is_tablet = false;
    state.is_desktop = true;
    state.is_desktopXL = false;
  } else {
    state.is_mobile = false;
    state.is_tablet = false;
    state.is_desktop = true;
    state.is_desktopXL = true;
  }
};

export default viewportDims;
